module.exports = __webpack_public_path__ + "static/img/吉祥物.fd57695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/吉祥物.png
// module id = 4l/Q
// module chunks = 74